import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { CloseBold16 as IconClose } from '@elfsight/icons';
// import IconClose from './icon-close-bold.svg?react';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { useFiltersTheme } from '../../../filters-theme-provider';

export type CloseIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const CloseIconButton = forwardRef<
  HTMLButtonElement,
  CloseIconButtonProps
>(({ onClick, ...forwardingProps }, forwardingRef) => {
  const { textColor } = useFiltersTheme();

  return (
    <Button
      {...forwardingProps}
      $textColor={textColor}
      onClick={onClick}
      ref={forwardingRef}
    >
      <IconClose />
    </Button>
  );
});

const Button = styled.button.attrs({
  className: createReadableClass({
    component: 'close-button',
    element: 'button'
  })
})<{
  $textColor: string;
}>`
  margin-right: -4px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: none;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  & svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }

  ${({ $textColor }) => css`
    color: ${getColorWithAlpha($textColor, 0.7)};
    background-color: transparent;

    &:hover {
      color: ${getColorWithAlpha($textColor, 1)};
      background-color: ${getColorWithAlpha($textColor, 0.05)};
    }
  `}
`;
